import { createRaycaster } from '../../core/createRaycaster'
import { System } from './System'

export class WorldSystem extends System {
  constructor(client) {
    super(client)
  }

  init() {
    this.raycast = createRaycaster({
      getBlockAt: loc => {
        const chunk = this.client.chunks.get(loc.chunkId)
        if (!chunk) return null
        const block = chunk.getBlockAtIdx(loc.voxelIdx)
        return block
      },
    })
  }
}
